import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import PromoCode from '@/components/promo-code/promo-code.vue';
import { ref, computed, onMounted } from 'vue';
import { trlMessage } from '@/services/i18n';
import { UiText } from '@huntflow/ui';
export default /*@__PURE__*/ _defineComponent({
    __name: 'total-price',
    props: {
        showPromoCode: { type: Boolean, default: true },
        price: { default: null },
        nominalPrice: { default: null },
        countParticipants: { default: 1 },
        promoCode: { default: null },
        editable: { type: Boolean, default: true },
        eventId: { default: '' },
        tariffId: { default: null }
    },
    emits: ["set-code"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const customerCode = ref(null);
        const promoCodeName = computed(() => customerCode.value?.code || '');
        const hasDiscount = computed(() => !!customerCode.value?.code);
        const sumWithOutDiscount = computed(() => {
            if (__props.editable || !hasDiscount.value) {
                return Number(__props.price) * __props.countParticipants;
            }
            return Number(__props.nominalPrice);
        });
        const sumWithDiscount = computed(() => {
            if (__props.editable) {
                return hasDiscount.value
                    ? Number(customerCode.value?.price_with_discount) * __props.countParticipants
                    : 0;
            }
            return Number(__props.price) * __props.countParticipants;
        });
        onMounted(() => {
            customerCode.value = __props.promoCode;
        });
        function handleSetPromoCode(code) {
            customerCode.value = code;
            emit('set-code', code);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style.sum)
                }, [
                    _createTextVNode(_toDisplayString(_unref(trlMessage)('event.price.total.title')) + ":  ", 1),
                    _createElementVNode("div", {
                        class: _normalizeClass(hasDiscount.value ? _ctx.$style.strike : '')
                    }, [
                        _createVNode(_unref(UiText), {
                            weight: hasDiscount.value ? '' : 'medium'
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(trlMessage)('event.price.total.sum', { price: sumWithOutDiscount.value })), 1)
                            ]),
                            _: 1
                        }, 8, ["weight"])
                    ], 2),
                    (hasDiscount.value)
                        ? (_openBlock(), _createBlock(_unref(UiText), {
                            key: 0,
                            class: _normalizeClass(_ctx.$style.discount),
                            weight: "medium"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(trlMessage)('event.price.total.sum', { price: sumWithDiscount.value })), 1)
                            ]),
                            _: 1
                        }, 8, ["class"]))
                        : _createCommentVNode("", true)
                ], 2),
                (__props.showPromoCode)
                    ? (_openBlock(), _createBlock(PromoCode, {
                        key: 0,
                        "promo-code": promoCodeName.value,
                        editable: __props.editable,
                        "event-id": __props.eventId,
                        "tariff-id": __props.tariffId,
                        onSetCode: handleSetPromoCode
                    }, null, 8, ["promo-code", "editable", "event-id", "tariff-id"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
